// app/(industrialBelt)/industrialBelt/ClientWrapper.js
'use client'

import { ConfigProvider, Empty, Flex, Pagination, Row, Col, Typography, Carousel, Spin } from 'antd';
import { useState, useEffect, useRef, useCallback } from 'react'
import { useApi } from '@/context/hooks/useApi';
import Image from 'next/image';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import ProductItem from "@/components/common/ProductItem/product";

export default function ClientWrapper({ id, cydBaseInfo, cydInfoDesc, type, cla }) {


    const [industrialBeltId, setId] = useState(id);


    const [cydListInfo, setCydListInfo] = useState(cydBaseInfo);
    const [cydInfo, setCydInfo] = useState(cydInfoDesc);
    const [cydInfoDetail, setCydInfoDetail] = useState(null);


    const [typeModal, setTypeModal] = useState(type);
    const [modalClass, setModalClass] = useState(cla);

    const mapRef = useRef(null); // 使用ref存储地图实例
    const toolBarRef = useRef(null);

    const api = useApi();

    const [activeTab, setActiveTab] = useState(1);


    const [productList, setProductList] = useState([]);
    const [shopList, setShopList] = useState([]);


    const [loading, setLoading] = useState(false);


    const tabsItems = [
        { label: `Source Goods`, key: 1 },
        { label: `Strength Factory`, key: 2 },
    ]


    useEffect(() => {

        // 避免重复加载AMap
        if (window.AMap) {
            initMap();
            return;
        }


        window._AMapSecurityConfig = {
            securityJsCode: 'c9c385412e9f8a7d57a72a8b0a8c43c6',
        };
        AMapLoader.load({
            key: '38a3bc90861e7b651807b7e5dc08e0d3', // 申请好的Web端开发者Key，首次调用 load 时必填
            // version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
            lang: 'en',
            plugins: [
                'AMap.DistrictSearch',
                'AMap.Polygon',
                'AMap.Marker',
                'AMap.ToolBar',
            ], // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        })
            .then((AMap) => {
                initMap();

            })
            .catch((e) => { });


        return () => {
            // 清理地图实例
            if (mapRef.current) {
                mapRef.current.destroy();
                mapRef.current = null;
            }
            if (toolBarRef.current) {
                toolBarRef.current = null;
            }
        };
    }, [])

    useEffect(() => {
        // 当id变化时加载对应工业带数据
        if (mapRef.current && industrialBeltId) {
            loadIndustrialBeltData(industrialBeltId);
        }
    }, [industrialBeltId]);


    useEffect(() => {

        let cla = 'cyd_base_list_bx'
        //1-产业带首页 2-产业带信息 3-产业带详情 4-工厂
        switch (typeModal) {
            case 1:
                cla = 'cyd_base_list_bx'

                if (!mapRef.current) break;

                mapRef.current.clearMap();
                mapRef.current.setZoomAndCenter(5, [105.602725, 37.076636]);
                mapRef.current.setStatus({
                    dragEnable: false,
                    zoomEnable: false,
                });

                toolBarRef?.current?.hide?.();

                break;

            case 2:
                cla = 'cyd_base_info_bx'
                break;

            case 3:
                cla = 'cyd_base_details_bx'
                break;
            default:
                break;
        }

        setModalClass(cla)

    }, [typeModal]);

    const initMap = () => {

        try {
            let newMap = new AMap.Map('map_container', {
                zoomEnable: false,
                dragEnable: false,
                viewMode: '3D', // 是否为3D地图模式
                zoom: 5, // 初始化地图级别
                lang: 'en',
                center: [105.602725, 37.076636], // 初始化地图中心点位置
            });
            let newToolBar = new AMap.ToolBar({
                visible: false,
                position: {
                    top: '110px',
                    right: '40px',
                },
            });

            newMap.addControl(newToolBar);
            // 存储到 ref
            mapRef.current = newMap;
            toolBarRef.current = newToolBar;

            if (industrialBeltId) {
                setTypeModal(2);

                circle(newMap, newToolBar, cydInfo)

            }

        } catch (error) {
            console.log("🚀 ~ initMap ~ error:", error)

        }
    }

    const circle = (mapInstance, toolBarInstance, cyInfo) => {
        try {
            const url = cyInfo.area
                ? cyInfo.area
                : cyInfo.city
                    ? cyInfo.city
                    : cyInfo.prov;
            const level = cyInfo.area ? 'district' : 'city';

            AMap.plugin('AMap.DistrictSearch', function () {
                var districtSearch = new AMap.DistrictSearch({
                    subdistrict: 1,
                    extensions: 'all',
                    level,
                });

                districtSearch.search(url, function (status, result) {
                    if (status == 'complete') {
                        var bounds = result.districtList[0].boundaries;
                        if (bounds) {
                            let polygon = {};
                            for (var i = 0, l = bounds.length; i < l; i++) {
                                polygon = new AMap.Polygon({
                                    map: mapInstance,
                                    strokeWeight: 1,
                                    strokeColor: '#0091ea',
                                    fillColor: '#80d8ff',
                                    fillOpacity: 0.2,
                                    path: bounds[i],
                                });
                            }
                            mapInstance.setFitView([polygon], false, [10, 10, 600, 10]);
                            mapInstance.setStatus({ dragEnable: true, zoomEnable: true });
                        }
                    }
                });
                toolBarInstance.show();
                marker(mapInstance, cyInfo.shopList);
            });
        } catch (error) {
            console.log("🚀 ~ circle ~ error:", error)

        }
    }

    const marker = (mapInstance, shopList) => {
        shopList.forEach((item, index) => {
            if (item.coordinates) {
                const arr = item.coordinates.split(',').map((i) => Number(i));
                var marker = new AMap.Marker({
                    position: new AMap.LngLat(arr[0], arr[1]),
                    content: markerIcon(item.headPicUrl),
                    anchor: 'bottom-center',
                });
                // marker.on('click', this.markerClick.bind(_this, item));
                mapInstance.add(marker);
            }
        });
    }

    const markerIcon = (url) => {
        return `<div class="markerIcon_bg">
        <img src=${url} class="markerIcon_bg_icon" />
      </div>`;
    }


    const loadIndustrialBeltData = async (id) => {
        if (!mapRef.current) return;

        try {
            const res = await api.get('mtop.shop.cyd.detail.info', { data: { industrialBeltId: id, i18n: true, lang: 'en' } })
            setCydInfoDetail(res);
            setTypeModal(3);
            setActiveTab(1);
            setShopList([])
            loadProductList(id)

        } catch (error) {
            console.log("🚀 ~ loadIndustrialBeltData ~ error:", error)

        } finally {
            setLoading(false);
        }
    }


    const loadIndustrialBeltList = async (id) => {
        if (!mapRef.current) return;

        try {
            const res = await api.get('mtop.shop.pc.cyd.map.shopList', { data: { industrialBeltId: id, i18n: true, lang: 'en' } })
            setCydInfo(res);
            setTypeModal(2);
            circle(mapRef.current, toolBarRef.current, res)

        } catch (error) {
            console.log("🚀 ~ loadIndustrialBeltData ~ error:", error)

        } finally {
            setLoading(false);
        }

    }

    const loadProductList = async (id) => {
        try {
            let res = await api.get('mtop.search.app.product.industry.search', { data: { "industryUnique": id, "requestId": "", "pageNo": 1, "pageSize": 100, "sortType": 0 } })
            setProductList(res?.products || []);
        } catch (error) {
            console.log("🚀 ~ loadProductList ~ error:", error)

        } finally {
            setLoading(false);
        }
    }

    const loadShopList = async () => {
        try {
            let res = await api.get(' mtop.search.shop.industry.search', { data: { "industryUnique": cydInfoDetail.industrialBeltId, "requestId": "", "pageNo": 1, "pageSize": 100, "sortType": 0 } })
            setShopList(res?.shops || []);


        } catch (error) {
            console.log("🚀 ~ loadShopList ~ error:", error)

        } finally {
            setLoading(false);
        }
    }

    const handleChangeList = item => {
        setLoading(true);
        loadIndustrialBeltList(item.industrialBeltId);
    }

    const handleToShop = item => {
        window.open(`/shop/${item.id || item.shopId}`)
    }


    const handleEntering = () => {
        setLoading(true);
        setProductList([]);
        loadIndustrialBeltData(cydInfo.industrialBeltId);
    }

    const handleChangeTabs = item => {

        if (item.key == 2 && shopList.length == 0) {
            setLoading(true);
            loadShopList();
        }
        setActiveTab(item.key);

    }

    const handleToProduct = (e, item) => {
        e.stopPropagation();
        window.open(`/productdetail/${item.id}`)

    }


    return (
        <div className='industrial_belt_content'>
            <div className='map_box'>
                <div id="map_container"></div>
            </div>

            <div className='box_warp'>

                <Spin spinning={loading} fullscreen></Spin>

                <div className={`cyd_info_bx ${modalClass}`}>
                    {
                        typeModal == 1 && cydListInfo.map((item, index) => <div className='cyd_base_item' key={index} onClick={() => handleChangeList(item)}>
                            <div className='cyd_base_item_img'>
                                <Image src={item.pic} alt={item.industrialBeltName} style={{ objectFit: 'contain' }} fill />
                            </div>
                            <div className='cyd_base_item_title'>{item.industrialBeltName}</div>
                            <div className='cyd_base_item_line'>{item.address}</div>
                        </div>)
                    }

                    {
                        typeModal == 2 && <>

                            <div className='back_item' onClick={() => setTypeModal(1)}><LeftOutlined /> All ​​Industrial Belt​​s</div>
                            <div className='title'>{cydInfo?.industrialBeltI8nName}</div>
                            <div className='address'>{cydInfo?.address}</div>
                            <div className='pic'>
                                {/* <Image src={cydListInfo.filter(item => item.industrialBeltId == cydInfo.industrialBeltId)[0].pcIcon} alt={cydInfo?.industrialBeltName} fill  style={{ objectFit: 'contain' }}  /> */}
                                <Image src={cydInfo?.pic} alt={cydInfo?.industrialBeltName} fill style={{ objectFit: 'contain' }} />
                            </div>
                            <Typography.Paragraph className='introduction' ellipsis={{ rows: 4 }}>{cydInfo?.introductionI18n}</Typography.Paragraph>
                            <Carousel
                                className='shop_line'
                                arrows={cydInfo?.industrialBeltShopVOList?.length > 4 || false}
                                slidesToShow={4}
                            >
                                {
                                    cydInfo?.shopList?.map((item, key) => <div className='shop_item' onClick={() => handleToShop(item)}>
                                        <div className='shop_item_pic'>
                                            <Image src={item.headPicUrl} alt={item.name} fill style={{ objectFit: 'contain' }} />
                                        </div>
                                        <Typography.Paragraph className='shop_item_name' ellipsis={true}>{item.i18nName}</Typography.Paragraph>
                                    </div>)
                                }
                            </Carousel>
                            <Flex justify='end'>
                                <div className='come_in' onClick={handleEntering}>View Details <RightOutlined /></div>
                            </Flex>
                        </>
                    }

                    {
                        typeModal == 3 && <>
                            <div className='back_item' onClick={() => setTypeModal(2)}><LeftOutlined /> Back</div>


                            <Carousel
                                className='cyd_pic_info'
                                arrows={cydInfoDetail?.promotionalPics?.length > 4 || false}
                                slidesToShow={4}
                            >
                                {
                                    cydInfoDetail?.promotionalPics.map((item, key) => <div className='cyd_pic_info_item' key={key}>
                                        <div className='cyd_pic_info_item_pic'>
                                            <Image src={item} alt={key} fill style={{ objectFit: 'cover' }} />
                                        </div>
                                    </div>)
                                }
                            </Carousel>

                            <div className='cyd_name_info'>{cydInfoDetail.industrialBeltName}<span>{cydInfoDetail.address}</span></div>

                            <div className='cyd_desc_info'>{cydInfoDetail.introduction}</div>


                            <div className='shop_list'>
                                <Row gutter={16} wrap={false}>

                                    {
                                        cydInfoDetail?.industrialBeltShopVOList.map((item, key) => <Col span={4} className='shop_item' onClick={() => handleToShop(item)} key={key}>
                                            <div className='shop_item_pic_bx'>
                                                <div className='shop_item_pic'>
                                                    <Image src={item.factoryHead} alt={item.companyName} fill style={{ objectFit: 'contain' }} />
                                                </div>
                                            </div>
                                            <Typography.Paragraph className='shop_item_name' ellipsis={true}>{item.companyName}</Typography.Paragraph>

                                            <div className='shop_item_desc'>
                                                <Typography.Paragraph className='shop_item_desc_name' ellipsis={{ rows: 2 }}>{item.companyName}</Typography.Paragraph>
                                                <Typography.Paragraph className='shop_item_desc_main' ellipsis={{ rows: 4 }}>{item.introduction}</Typography.Paragraph>
                                            </div>
                                        </Col>)
                                    }
                                </Row>
                            </div>

                            <div className='tab_box'>
                                {
                                    tabsItems.map((item, key) => <div onClick={() => handleChangeTabs(item)} className={`tab_item ${activeTab == item.key ? 'active' : ''}`} key={key}>{item.label}</div>)
                                }
                            </div>

                            {
                                activeTab == 1 && <Flex align="center" justify='center' wrap>

                                    {(productList.length > 0 && !loading) ? productList.map((item, key) => <ProductItem item={item} key={key} isOpen={true} />) : <Empty description="No products found" />}

                                </Flex>
                            }

                            {
                                activeTab == 2 && <Row gutter={16} wrap className='shop_list_box'>

                                    {(shopList.length > 0 && !loading) ? shopList.map((item, key) => <Col span={12} key={key}>
                                        <div className='shop_list_item' onClick={() => handleToShop(item)}>
                                            <div className='shop_list_item_name'>{item.name}</div>
                                            <div className='shop_list_item_main'>{item.mainSell}</div>

                                            <Row className='shop_list_item_prod'>
                                                {
                                                    item.products.map((item, index) => <Col span={6} key={index}>
                                                        <div className='shop_list_item_prod_img' onClick={(e) => handleToProduct(e, item)}>
                                                            <Image src={item.picUrl} alt={item.id} fill style={{ objectFit: 'cover' }} />
                                                        </div>
                                                    </Col>)
                                                }
                                            </Row>
                                        </div>
                                    </Col>) : <Empty description="No Shop found" style={{ margin: '0 auto' }} />}
                                </Row>
                            }

                        </>

                    }

                    {/* {typeModal != 1 && <div className='cyd_back_bx' onClick={() => setTypeModal(1)}>List</div>} */}

                </div>


            </div>



        </div>
    )
}